module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    attrs: {
      "id": "notes"
    },
    on: {
      "click": _vm.hideNotes
    }
  }, [_c('nav', {
    staticClass: "nav is-hidden-tablet",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "nav__mobile-header"
  }, [_c('button', {
    on: {
      "click": _vm.hideNotes
    }
  }, [_c('span', {
    staticClass: "icon icon--close"
  })]), _vm._v(" "), _c('a', {
    staticClass: "home-link",
    attrs: {
      "title": "Home"
    },
    on: {
      "click": _vm.hideNotes
    }
  }, [_c('logo')], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "inner",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('article', {
    staticClass: "textbody justify-center"
  }, [_c('section', {
    staticClass: "h6plus",
    domProps: {
      "innerHTML": _vm._s(_vm.html('site.notes-text'))
    }
  }), _vm._v(" "), _c('footer', [_c('h3', [_vm._v("A Note on The Cinemagraphs")]), _vm._v(" "), _c('section', {
    staticClass: "h7 nimbus-sans",
    domProps: {
      "innerHTML": _vm._s(_vm.html('site.notes-footer'))
    }
  }), _vm._v(" "), _c('credits', {
    staticClass: "is-hidden-tablet"
  })], 1)]), _vm._v(" "), _c('footer', {
    staticClass: "is-hidden-tablet"
  }, [_c('app-footer', {
    attrs: {
      "site": _vm.site
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1019afad"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotesPane.vue
// module id = 374
// module chunks = 1